<template>
  <fairstone-plan-form mode="edit" />
</template>

<script>
import Form from "./Form.vue";
export default {
  name: "FairstonePlansEdit",
  components: {
    FairstonePlanForm: Form,
  },
};
</script>
